<template>
    <a-modal v-model="visible" title="项目曾获奖励情况明细" width="67%" centered :maskClosable="false" :keyboard="false" class="diyModelCls">
        <a-spin :spinning="loading">
            <vxe-table
                ref="itemTable"
                size="mini"
                resizable
                keep-source
                auto-resize
                row-id="id"
                align="left"
                header-align="center"
                highlight-hover-row
                show-overflow="tooltip"
                :data="editItemData"
                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
            >
                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                <vxe-table-column field="hjsj" title="获奖时间" width="150" align="center"></vxe-table-column>
                <vxe-table-column field="jlmc" title="奖励名称" width="300"></vxe-table-column>
                <vxe-table-column field="jldj" title="等级" width="120" align="center"></vxe-table-column>
                <vxe-table-column field="jjse" title="奖金数额(元)" width="110" header-align="center" align="right">
                    <template v-slot="{ row }">
                        <span> {{ $FG_util.formatNumber(row.jjse, "0.00") }} </span>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="sjbm" title="授奖部门" min-width="100"></vxe-table-column>
                <vxe-table-column title="附件" width="150" align="center">
                    <template v-slot="scope">
                        <span class="btn_edit" @click="attachShow(scope.row)">相关材料</span>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
        </template>
        <AttachModalDownload :attachCfg.sync="attachProps" />
    </a-modal>
</template>

<script>
export default {
    name: "HjqkmxForm",
    props: ["showHjqkmxEdit", "dataId", "cgsbbmxid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 编辑数据
            editData: {},
            editItemData: [],
            editDataLoading: false,
            editProps: {
                showHjqkmxEdit: false,
                cgsbbmxid: null
            },
            attachProps: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_HJQK",
                fkfield: "ID",
                attachSource: "CG1001"
            }
        };
    },
    computed: {
        visible: {
            get() {
                return this.showHjqkmxEdit;
            },
            set(newVal) {
                this.$emit("update:showHjqkmxEdit", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    // 修改，加载数据
                    this.loadItemData();
                }
            },
            immediate: true
        }
    },
    methods: {
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemHjqkmx",
                    {
                        cgsbbmxid: this.cgsbbmxid,
                        sort: {
                            field: "XH",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        },
        // 附件管理
        attachShow(row) {
            // 设置编辑记录id
            this.attachProps.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps.visible = true;
        }
    }
};
</script>
